export default "__VITE_ASSET__C6Qgg$3B__"